import React from 'react';
import { ThermometerSnowflake, Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-muted/50 border-t" data-id="element-132">
      <div className="container mx-auto px-4 py-12 md:px-6 lg:py-16" data-id="element-133">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-134">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-135">
            <div className="flex items-center gap-2" data-id="element-136">
              <ThermometerSnowflake className="h-6 w-6 text-primary" data-id="element-137" />
              <span className="text-lg font-bold" data-id="element-138">
                Sunflow Heated Driveways
              </span>
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-139">
              Professional heated driveway installation and outdoor heating
              systems across Ontario. Keep your home safe and accessible all
              winter long.
            </p>
            <div className="flex gap-4" data-id="element-140">
              <a href="https://www.facebook.com/hellosunflow" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-141">
                <Facebook className="h-5 w-5" data-id="element-142" />
                <span className="sr-only" data-id="element-143">Facebook</span>
              </a>
              <a href="https://www.instagram.com/sunflowsolarandroofing/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-144">
                <Instagram className="h-5 w-5" data-id="element-145" />
                <span className="sr-only" data-id="element-146">Instagram</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-147">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-148">
              Services
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-149">
              <li data-id="element-150">Heated Driveways</li>
              <li data-id="element-151">Heated Walkways</li>
              <li data-id="element-152">Patio Heating</li>
              <li data-id="element-153">Snow Melting Systems</li>
              <li data-id="element-154">System Maintenance</li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-155">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-156">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-157">
              <li data-id="element-158">Toronto & GTA</li>
              <li data-id="element-159">Ottawa</li>
              <li data-id="element-160">Hamilton</li>
              <li data-id="element-161">London</li>
              <li data-id="element-162">Barrie & Simcoe</li>
              <li data-id="element-163">All of Ontario</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-164">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-165">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-166">
              <li className="flex items-start gap-2" data-id="element-167">
                <MapPin className="h-5 w-5 shrink-0 text-primary" data-id="element-168" />
                <span data-id="element-169">30 Quarry Ridge Rd, Barrie, ON L4M 7G1</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-170">
                <Phone className="h-5 w-5 shrink-0 text-primary" data-id="element-171" />
                <a href="tel:647-706-9908" className="hover:text-primary" data-id="element-172">
                  (647) 706-9908
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-173">
                <Mail className="h-5 w-5 shrink-0 text-primary" data-id="element-174" />
                <a href="mailto:info@sunflow.ca" className="hover:text-primary" data-id="element-175">
                  info@sunflow.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t pt-8 text-center text-sm text-muted-foreground" data-id="element-176">
          <p data-id="element-177">
            &copy; {new Date().getFullYear()} Sunflow Heated Driveways. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}